"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
class Toaster extends React.Component {
    render() {
        return (React.createElement(react_toastify_1.ToastContainer, { position: "bottom-right", autoClose: 3000, hideProgressBar: true, newestOnTop: false, closeOnClick: false, rtl: false, draggable: false, pauseOnHover: true, transition: react_toastify_1.Slide }));
    }
}
exports.Toaster = Toaster;
let isBeingUsed = false;
setInterval(() => {
    isBeingUsed = false;
}, 1500);
function notify(props) {
    if (isBeingUsed)
        return;
    if (props.type) {
        react_toastify_1.toast[props.type](props.message);
    }
    else {
        react_toastify_1.toast(props.message);
    }
    isBeingUsed = true;
}
exports.notify = notify;
//# sourceMappingURL=toaster.js.map